export const modalities = {
  text: 'Text',
}
export const taskTypes = {
  FRQ: 'Free response',
  MCQ: 'Multiple choice',
  bool: 'Boolean',
}
export const alarmCadences = {
  once: 'Only once',
  daily: 'Daily',
}
export const architectures = {
  llm: 'LLM',
  nn: 'Neural network',
  Transformer: 'Transformer',
}
export const allTags = {
  truthful: 'truthful',
  helpful: 'helpful',
  harmful: 'harmful',
  alignment: 'alignment',
  deceitful: 'deceitful',
}

export const viewOptions = {
  correct: 'Correct answers',
  incorrect: 'Incorrect answers',
  redacted: 'Redacted',
}
